export default __webpack_public_path__ + "static/media/vox-img-legacy-008.fbc58939.jpg";